import { I18NextPipe } from 'angular-i18next';
import { StorageType } from 'mbs-ui-shared@models';
import { StorageAccountState } from 'mbs-ui-shared@models/StorageAccount';

export const transformStorageStateValue = (i18N: I18NextPipe, storageAccountState: StorageAccountState): string => {
  if (storageAccountState === StorageAccountState.ReadOnly) return i18N.transform('shared:storages.accountState.readOnly');

  return storageAccountState;
};

export const showStorageState = (storageState: StorageAccountState): boolean => {
  return storageState !== StorageAccountState.FullyAccessible;
};

export const getDestinationKey = (i18N: I18NextPipe, storageType: StorageType): string => {
  const typeSupportTextContainer: StorageType[] = [StorageType.Azure, StorageType.OpenStack];

  if (typeSupportTextContainer.some((s) => s === storageType)) {
    return i18N.transform('shared:storages.destinationKey.container', { format: 'title' });
  }

  if (StorageType.LocalFS === storageType) {
    return i18N.transform('shared:storages.destinationKey.path', { format: 'title' });
  }

  return i18N.transform('shared:storages.destinationKey.bucket', { format: 'title' });
};
